import type { InterviewBatch } from 'types';

export function calculateTotalInterviews (interviewBatch: InterviewBatch): number {
  let total = 0;
  (interviewBatch.times || []).forEach(({ slots, candidates_per_slot }) => {
    total += (slots || []).length * candidates_per_slot;
  });
  return total;
}
